module.exports = __webpack_public_path__ + "img/premium-member.b53d7bf.svg";